import React from 'react';

const DisplayFormats = {
  dmy: 'dmy', // DDMMYYYY
  mdy: 'mdy', // MMDDYYYY
} as const;

type DisplayFormatsType = typeof DisplayFormats[keyof typeof DisplayFormats];

export default interface InputProps extends React.InputHTMLAttributes<HTMLSelectElement> {
  displayFormat?: DisplayFormatsType;
  dataPointer?: string;
  value?: string;
  dataCy?: string;
  invalid?: boolean;
  errorMsgHolderId?: string;
  locale?: string;
}

export { DisplayFormats };
